import React from 'react';
import { useQuery } from '@apollo/client/react';
import PopularPostList from './PopularPostList';
import { POPULAR_POSTS } from 'lib/graphql/queries/post';

/**
 * PopularPostListWithData Component
 *
 * Wrapper component that fetches popular posts data and passes it to PopularPostList.
 * Supports configurable variant for different layout contexts.
 *
 * @param props - Component props
 * @param props.variant - Layout variant: 'small' (single column) or 'main' (grid). Defaults to 'small'.
 * @returns PopularPostList component with fetched data
 */
const PopularPostListWithData = (
  props: PopularPostListWithDataProps,
): React.JSX.Element => {
  const { variant } = props;
  const { data, loading, networkStatus, error } = useQuery<any>(POPULAR_POSTS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      limit: 6,
      skip: 0,
    },
  });

  const isLoading = loading || networkStatus === 4;
  const posts = data && data.publishedPosts ? data.publishedPosts : [];

  return (
    <PopularPostList posts={posts} loading={isLoading} error={error} variant={variant} />
  );
};

export interface PopularPostListWithDataProps {
  /**
   * Layout variant for the post grid.
   * - 'small': Single column layout (for sidebars)
   * - 'main': Responsive grid layout (for full-width content areas)
   * @default 'small'
   */
  variant?: 'main' | 'small';
}

export default PopularPostListWithData;
